<template>
  <div class="order">
    <component :is="componentId"></component>
    <banner />
    <mainContainer />
    <footerBox />
  </div>
</template>

<script>
import banner from './component/banner'
import navbar from '@/components/navbar.vue'
import otoNavbar from '@/components/otoNavbar.vue'
import footerBox from '@/components/footer.vue'
import mainContainer from './component/mainContainer'
import { mapState } from 'vuex'
export default {
  name: 'Order',
  components: {
    navbar,
    otoNavbar,
    footerBox,
    banner,
    mainContainer
  },
  data () {
    return {
      componentId: null
    }
  },
  computed: {
    ...mapState('order', [
      'orderList'
    ])
  },
  created () {
    if (this.orderList[0]?.shippingRequired) {
      this.componentId = otoNavbar
    } else {
      this.componentId = navbar
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
